<template>
  <div>
    <div class="text-center">
      <p class="subtitle-1 font-weight-medium" style="color: #2661FF">
        {{ $t('pricing_model.create.step_3.title') }}
      </p>
      <p class="subtitle-2 font-weight-regular">
        <span class="font-weight-medium">
          {{ $t('common.success') }}
        </span>
        {{ $t('pricing_model.create.step_3.description') }}
        <span class="font-weight-medium">
          {{ $t('pricing_model.create.step_3.go_on') }}
        </span>
      </p>
    </div>
    <v-divider class="my-8"></v-divider>
    <v-card class="rounded-xl pa-4" flat style="border: 1px solid #BCBCBC">
      <v-card-title class="d-flex flex-column justify-start align-start">
        <p class="subtitle-1 font-weight-bold">
          {{ pricingModel.display_name }}
        </p>
        <p class="subtitle-2 font-weight-regular">
          {{ pricingModel.description }}
        </p>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <p class="subtitle-2 font-weight-regular black--text">Planes</p>
        <v-row>
          <v-col cols="12" md="6" v-for="plan in pricingModel.plans">
            <div class="d-flex" style="gap: 10px;">
              <v-icon
                :color="plan.color ? plan.color.hex : null"
                small
                class="mt-1"
              >
                fiber_manual_record
              </v-icon>
              <span class="body-2 font-weight-medium">
                {{ plan.display_name }}
              </span>
            </div>
            <div class="ml-6">
              <span class="body-2">
                {{
                  `Moneda: ${getCurrency(plan.currency_id).name} (${
                    getCurrency(plan.currency_id).code
                  })`
                }}
              </span>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <div class="d-flex justify-end align-center">
      <v-btn @click="finishPricing" color="#2661FF" class="rounded-lg my-8">
        <span style="color: white;">{{
          $t('pricing_model.create.step_3.go_dashboard')
        }}</span>
        <v-icon color="white">navigate_next</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'PricingModelCreateStep3',
  data() {
    return {
      step: 3
    }
  },
  computed: {
    ...mapState({
      pricingModel: ({ pricingModels: { pricingModel } }) => pricingModel,
      currencies: ({ countries: { currencies } }) => currencies
    })
  },
  methods: {
    ...mapMutations({
      resetPricingModel: 'pricingModels/resetPricingModel'
    }),
    getCurrency(currency_id) {
      const currency = this.currencies.find(
        currency => currency.id === currency_id
      )
      return currency
    },
    finishPricing() {
      this.resetPricingModel()
      this.$emit('nextStep', { step: this.step })
      this.$router.replace({ name: 'organizationPricingModels' })
    }
  }
}
</script>

<style lang="scss" scoped></style>
